export const MAX_MESSAGE_LENGTH = 50000;

export const MAX_MESSAGE_LENGTH_ERROR_TEXT = `The message is too long. The max. length is ${MAX_MESSAGE_LENGTH} symbols.`;

export const CHAT_FORM_FIELD_NAMES = {
  TEXT: 'text',
  SCHEDULED_DATE: 'scheduledDate',
  FILES: 'files',
} as const;

export const DEFAULT_CHAT_FORM_VALUES = {
  [CHAT_FORM_FIELD_NAMES.TEXT]: '',
  [CHAT_FORM_FIELD_NAMES.SCHEDULED_DATE]: null,
};

export const ATTACHMENT_TYPES = {
  FILE: 'file',
  MEDIA: 'media',
} as const;

export const CHAT_OPEN_EVENT = 'open';

export const DURATION_HEADER_NAME = 'x-amz-meta-duration';

export const CHAT_MESSAGE_TYPES = {
  SYSTEM: 'system',
  PLAIN: 'plain',
  MORPHEUS: 'morpheus',
  COACHING_SESSION_RECAP: 'coaching_session_recap',
  DELETED: 'deleted',
  WIDGETS: 'widgets',
  MORPHEUS_SUGGESTION: 'morpheus_suggestion',
} as const;

export const MORPHEUS_USER_ID = '00000000-0000-0000-0000-000000000000';
